export const contactsData = {
    email: 'rohitkrrt@gmail.com',
    phone: '+91 7004608394',
    address: 'Delhi, New Delhi, India - 110047 ',

    sheetAPI: ''
}